<template>
  <base-floating-card @close="close">
    <div id="delete-event-card">
      <delete-contact-art class="art" />
      <div id="heading-and-buttons">
        <h5 id="delete-event-heading">Delete {{ contactName }}?</h5>
        <div id="delete-event-buttons">
          <round-button-with-icon
            :icon="processing ? 'spinner' : 'x'"
            @click="close"
          />
          <round-button-with-icon
            :icon="processing ? 'spinner' : 'checkmark'"
            @click="confirm"
          />
        </div>
      </div>
    </div>
  </base-floating-card>
</template>
<script>
import BaseFloatingCard from "../BaseFloatingCard.vue";
import RoundButtonWithIcon from "../../RoundButtonWithIcon.vue";
import DeleteContactArt from "../../Illustrations/DeleteContact.vue";
export default {
  data() {
    return {
      processing: false,
    };
  },
  computed: {
    contactName() {
      if (this.contact) {
        return `${this.contact.given_name} ${this.contact.family_name}`;
      } else {
        return "this contact";
      }
    },
  },
  methods: {
    close() {
      if (!this.processing) {
        this.$emit("close");
      }
    },
    async confirm() {
      this.processing = true;
      let payload = {
        userKey: {
          userId: this.contact.userId,
          tenantId: this.contact.tenantId,
        },
        tenantId: this.$store.getters.user.tenantId,
        testing: false,
      };
      await this.$store.dispatch("deleteContact", payload);
      this.processing = false;
      this.$router.push("/");
      this.close();
    },
  },
  created() {},
  components: {
    BaseFloatingCard,
    RoundButtonWithIcon,
    DeleteContactArt,
  },
  emits: ["close"],
  props: ["contact"],
};
</script>
<style scoped>
@media screen {
  #delete-event-card {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;
    padding: 50px;
  }

  .art {
    width: 150px;
    height: 150px;
  }

  #heading-and-buttons {
    margin: auto;
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  #delete-event-buttons {
    display: flex;
    width: 100px;
    justify-content: space-between;
  }
  @media (min-width: 800px) {
    #delete-event-card {
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      padding: 50px;
      width: 400px;
      height: 125px;
    }

    .art {
      margin-right: 70px;
    }

    #heading-and-buttons {
      margin: auto;
      display: flex;
      flex-direction: column;
      align-items: center;
    }

    #delete-event-buttons {
      display: flex;
      width: 100px;
      justify-content: space-between;
    }
  }
}
</style>
